import { render, staticRenderFns } from "./SearchLocales.vue?vue&type=template&id=243f7590"
import script from "./SearchLocales.vue?vue&type=script&lang=js"
export * from "./SearchLocales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports